import GeneralTracker from '../GeneralTracker';


const MOVE_WHEN_CLOSING_THRESHOLD = 90;


export default class PeekWindowTracker extends GeneralTracker {
  CAPTURE_NAME = 'ui:peek:usage';
  EVENT_GROUP = 'engage';
  VERSION = '1';

  ACTIONS = {
    move: 'movePeekWindow',
    resize: 'resizePeekWindow',
    click: 'clickOnPeekWindow',
    goto: 'goToProfileFromPeekWindow',
    close: 'closePeekWindow',
  };

  init(service) {
    super.init(service);
    this.currentMovingPeekWindow = {};
  }

  setHandlers() {
    const service = this.getService();

    service.on('interactWithPeekWindow', this.onInteraction);
  }

  onInteraction = (payload) => {
    const { action } = payload;
    const moveResizeActions = ['move', 'resize'];
    const otherActions = ['click', 'goto', 'close'];

    if (moveResizeActions.includes(action)) {
      this.handleMoveResize(payload);
    } else if (otherActions.includes(action)) {
      this.handleOther(payload);
    }
  };

  handleMoveResize = (payload) => {
    const { action, moment, event, info } = payload;

    if (moment === 'start') {
      this.interactionStart(event, action, info);
    } else if (moment === 'end') {
      this.interactionEnd(info);
    } else if (moment === 'during') {
      this.interacting(event, info);
    }
  };

  handleOther = (payload) => {
    const { action } = payload;

    const actions = {
      click: this.onClick,
      goto: this.onGoToProfile,
      close: this.onClose,
    };

    actions[action](payload);
  };

  interactionStart = (event, action, info) => {
    const { broadcaster, index } = info;

    const draggableParent = event.target.closest('.react-draggable');

    this.currentMovingPeekWindow = {
      parent: draggableParent,
      interaction: action,
      broadcaster,
      index,
      start: Date.now(),
      steps: [],
    };
  };

  interactionEnd = (info) => {
    const { start, interaction, parent } = this.currentMovingPeekWindow;
    const { broadcaster, index } = info;
    const end = Date.now();
    const duration = end - start;
    const screen = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
    const size = {
      width: parseInt(parent.style.width, 10),
      height: parseInt(parent.style.height, 10),
    };

    delete this.currentMovingPeekWindow.parent;
    const trackPayload = {
      action: interaction,
      labels: {
        ...this.currentMovingPeekWindow,
        movements: this.currentMovingPeekWindow.steps.length,
        end,
        duration,
        broadcaster,
        index,
        screen,
        size,
      },
    };

    if (duration > MOVE_WHEN_CLOSING_THRESHOLD) {
      this.track(trackPayload);
    }

    this.currentMovingPeekWindow = {};
  };

  interacting = (payload) => {
    const { steps } = this.currentMovingPeekWindow;
    const lastStep = steps?.at(-1);

    if (!lastStep) {
      this.currentMovingPeekWindow.pageTime = payload.timeStamp;
    }

    const step = {
      coord: {
        x: payload.x,
        y: payload.y,
      },
      arrow: {
        x: lastStep ? payload.x - lastStep.coord.x : 0,
        y: lastStep ? payload.y - lastStep.coord.y : 0,
      },
      pageTime: payload.timeStamp,
      timeDiff: lastStep ? payload.timeStamp - lastStep.pageTime : 0,
    };

    steps.push(step);
    this.currentMovingPeekWindow.steps = steps;
  };

  getSimpleInteractionPayload = (payload) => {
    const { action, info } = payload;
    const { broadcaster, index } = info;

    const trackPayload = {
      action,
      labels: {
        interaction: action,
        broadcaster,
        index,
      },
    };

    return trackPayload;
  };

  onClick = (payload) => {
    this.track(this.getSimpleInteractionPayload(payload));
  };

  onGoToProfile = (payload) => {
    this.track(this.getSimpleInteractionPayload(payload));
  };

  onClose = (payload) => {
    this.track(this.getSimpleInteractionPayload(payload));
  };

  track(payload) {
    const { action, labels } = payload;

    const trackPayload = {
      action: this.ACTIONS[action],
      labels,
    };

    super.track(trackPayload);
  }
}
